"use strict";

var EventEmitter = {
  _events: {},
  dispatch: function dispatch(event, data) {
    if (!this._events[event]) return;
    this._events[event].forEach(function (callback) {
      return callback(data);
    });
  },
  subscribe: function subscribe(event, callback) {
    if (!this._events[event]) this._events[event] = [];
    this._events[event].push(callback);
  }
};
module.exports = {
  EventEmitter: EventEmitter
};